import { FC, ReactNode } from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import AdminDashboard from "./AdminDashboard";
import AdminLogin from "./AdminLogin";

const Admin: FC<AdminProps> = ({ view }) => {
  const componentToRender: Record<ViewType, ReactNode> = {
    login: <AdminLogin />,
    dashboard: <AdminDashboard />,
    reportView: <AdminDashboard view="reportView" />,
  };

  return (
    <div className="relative">
      <div
        className={`min-h-dvh h-dvh flex flex-col ${
          view === "login" ? "bg-gray-7" : "bg-white"
        }`}
      >
        <Header
          mode={view === "login" ? "dark" : "light"}
          type={view === "dashboard" ? "admin" : "normal"}
          className="border-b border-gray-3"
        />
        <div className="flex-grow overflow-auto">{componentToRender[view]}</div>
        <Footer mode="dark" type="short" />
      </div>
    </div>
  );
};

export default Admin;

type ViewType = "login" | "dashboard" | "reportView";

interface AdminProps {
  view: ViewType;
}
